import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import YumSetupActivityData, { IDispatchProps, IStateProps } from './YumSetupActivityData'
import { setOnboardingStatusToActivityData } from '../../views/RegisterUser/store/RegisterUserActions'

const mapStateToProps = (state: IGlobalState, { buttonText }: IStateProps): IStateProps => ({
  buttonText,
})

const mapDispatchToProps: IDispatchProps = {
  setOnboardingStatusToActivityData,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumSetupActivityData)
